import React from 'react';
import styled from 'styled-components';
import Button from '../commons/component/button';
import { createFastRegistryRequest } from '../api/customer/fast-registry';
import axios from 'axios';
import Recaptcha from '../commons/component/captcha/recaptcha';

export default class ConfirmarDescadastroComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'idle'
    };

    this.doConfirmaDescadastro = this.doConfirmaDescadastro.bind(this);
  }

  async doConfirmaDescadastro(token) {
    this.setState({ status: 'loading' });
    try {
      const captcha_response = await this.captcha.getResponse();

      var request = createFastRegistryRequest({ token, event: 'optOut', captcha_response });
      const { data } = await axios(request);

      this.setState({ status: 'success', data });
    } catch (error) {
      if (error === 'CAPTCHA_LIB_NEVER_LOADED') {
        console.log('falha ao tentar se conectar com captcha, tentando novamente em 1 segundo');
        setTimeout(() => this.doConfirmaDescadastro(token), 1000);
      } else {
        console.error(error);
        this.captcha.reset();
        this.setState({ status: 'error', error });
      }
    }
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);

    if (this.state.status === 'idle') {
      this.doConfirmaDescadastro(urlParams.get('token'));
    }
  }

  render() {
    const urlParams = new URLSearchParams(this.props.location.search);
    return (
      <div className="entrar__wrapper">
        {this.state.status === 'loading' && (
          <LoaderWrapper>
            <div className="loader" />
          </LoaderWrapper>
        )}
        {this.state.status === 'success' && (
          <Description>
            O cancelamento de sua inscrição <b>foi realizado com sucesso</b>.
          </Description>
        )}

        <Recaptcha ref={ref => (this.captcha = ref)} />
        {this.state.status === 'error' && (
          <ErrorMessage>Não foi possível realizar o cancelamento.</ErrorMessage>
        )}
        {this.state.status === 'error' && (
          <DescadastroButton
            primary
            disabled={this.state.status === 'loading'}
            loading={this.state.status === 'loading'}
            onClick={() => this.doConfirmaDescadastro(urlParams.get('token'))}
          >
            tentar novamente
          </DescadastroButton>
        )}
      </div>
    );
  }
}

const Description = styled.p`
  color: #666;
  text-align: center;
  font-size: 18px;
`;

const DescadastroButton = styled(Button)`
  margin: 0 auto;
  display: block;
`;

const ErrorMessage = styled.p`
  color: red;
  text-align: center;
  margin-top: 15px;
`;

const LoaderWrapper = styled.p`
  position: relative;
  margin: 50px auto;
`;
